/** The wordmark of Tafo as an image, red on a white surface (a card, a window). */
export function Logo() {
  return <img className="logo" src="/tafo-logo.png" alt="Tafo" width={95} height={24} />;
}
